var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-page',[_c('ui-button',{staticClass:"mt-5",attrs:{"type":"secondary","label":"Start Test"},on:{"click":_vm.run}}),_vm._v(" "),_c('div',{staticClass:"mt-5",attrs:{"id":"results"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }